<script setup>
import axios from "axios";
import {ref} from "vue";

const products=ref([])
/*async function getAccessToken() {
  const data = new URLSearchParams()
  data.append('grant_type', 'client_credentials')
  data.append('client_id', '9f072e34-5b95-49fe-9505-d839e0d42928') // از مرحله بالا
  data.append('client_secret', 'RJjDpdtKyYAxOdw0Ge8BJVNkoLdsO47yKnzZhqaa')

  const res = await axios.post('https://fixstyle.ir/oauth/token', data)
  return res.data.access_token
}*/
// const token = await getAccessToken()
axios.get('https://fixstyle.ir/api/public-products')
    .then(res => {
      console.log('products', res)
      products.value=res.data
    })
    .catch(() => {
      console.error('error getting products')
    })
/*console.log(token)

const res = await axios.get('https://fixstyle.ir/api/product2', {
  headers: {
    Authorization: `Bearer ${token}`
  }
})

console.log(res.data)*/
</script>

<template>
  <div class="row">
    <div class="col-7 border">
      <h1>home</h1>
      <ul>
        <li v-for="item in products" :key="item.id">
          {{ item.id }} -   {{ item.name }} -{{ item.price }} -
          <span>{{ item.created_at }} </span>
        </li>
      </ul>
    </div>
  </div>
  <hr>
</template>

<style scoped>

</style>